var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickmill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0428\\u0430\\u0440_1",
    "data-name": "\\u0428\\u0430\\u0440 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2777.03 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #810000;\n      }\n\n      .cls-2 {\n        fill: #303030;\n      }\n\n      .cls-3 {\n        fill: #d7000f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m793.86,100.65h-95.04v-56.01h258.82v56.01h-95.04v241.01h-68.73V100.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m994.55,44.64h68.74v297.01h-68.74V44.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1193.76,327.02c-24.47-13.15-43.7-31.4-57.7-54.74-14-23.34-21-49.71-21-79.13s7-55.8,21-79.13c14-23.34,33.24-41.58,57.7-54.73,24.47-13.15,51.98-19.73,82.53-19.73,25.74,0,49.01,4.53,69.8,13.58,20.79,9.06,38.25,22.07,52.4,39.04l-44.13,40.73c-20.09-23.19-44.98-34.79-74.68-34.79-18.39,0-34.79,4.03-49.22,12.09-14.42,8.06-25.67,19.3-33.74,33.73-8.06,14.42-12.09,30.83-12.09,49.22s4.03,34.79,12.09,49.22c8.06,14.43,19.31,25.67,33.74,33.74,14.42,8.06,30.83,12.09,49.22,12.09,29.7,0,54.59-11.73,74.68-35.22l44.13,40.73c-14.14,17.26-31.68,30.41-52.61,39.46-20.94,9.05-44.28,13.58-70.01,13.58-30.27,0-57.64-6.58-82.11-19.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1552.93,224.97l-39.89,41.58v75.1h-68.31V44.64h68.31v138.75l131.54-138.75h76.37l-123.04,132.38,130.26,164.63h-80.2l-95.04-116.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2029,341.66l-.42-178.21-87.4,146.81h-30.98l-86.98-142.99v174.39h-64.5V44.64h56.86l111.17,184.57,109.47-184.57h56.43l.85,297.01h-64.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2163.92,44.64h68.74v297.01h-68.74V44.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2303.09,44.64h68.74v241h148.93v56.01h-217.67V44.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2559.36,44.64h68.74v241h148.93v56.01h-217.67V44.64Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m730.66,411.71h-31.98v-18.84h87.09v18.84h-31.98v81.1h-23.13v-81.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1247.35,492.81l-19.28-27.84h-21.27v27.84h-23.13v-99.94h43.26c8.85,0,16.54,1.47,23.06,4.42s11.54,7.14,15.06,12.57c3.52,5.42,5.28,11.85,5.28,19.27s-1.78,13.83-5.35,19.2c-3.57,5.38-8.64,9.5-15.21,12.35l22.42,32.12h-24.84Zm-5.86-76.6c-3.62-3-8.9-4.5-15.84-4.5h-18.85v34.84h18.85c6.94,0,12.23-1.52,15.84-4.57,3.62-3.04,5.43-7.32,5.43-12.85s-1.81-9.92-5.43-12.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1739.9,471.39h-46.41l-8.85,21.41h-23.7l44.54-99.94h22.84l44.69,99.94h-24.27l-8.85-21.41Zm-7.28-17.56l-15.85-38.26-15.84,38.26h31.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m2168.92,392.87h45.4c10.85,0,20.44,2.07,28.77,6.21,8.33,4.14,14.8,9.97,19.41,17.49,4.62,7.52,6.93,16.27,6.93,26.27s-2.31,18.75-6.93,26.27c-4.61,7.52-11.09,13.35-19.41,17.49-8.33,4.14-17.92,6.21-28.77,6.21h-45.4v-99.94Zm44.26,80.95c9.99,0,17.97-2.78,23.92-8.35,5.95-5.57,8.92-13.11,8.92-22.63s-2.98-17.06-8.92-22.63c-5.95-5.57-13.93-8.36-23.92-8.36h-21.13v61.96h21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m2749.71,474.25v18.56h-77.38v-99.94h75.53v18.56h-52.54v21.7h46.4v17.99h-46.4v23.13h54.4Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "391.14 .46 349.5 72.66 191.82 72.66 152.36 141.1 68.8 141.1 149.91 .46 391.14 .46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "484.47 72.45 484.35 72.66 458.73 117.09 416.99 189.48 257.55 189.48 215.81 117.09 375.17 117.09 442.69 0 484.47 72.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.23 301.97 109.58 301.82 188.59 438.28 267.6 438.14 309.46 510.44 147.11 510.73 26.23 301.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.76 185.13 42.01 185.13 93.3 185.03 176.85 184.89 256.75 322.86 215.02 395.25 135.17 257.34 0 257.58 41.76 185.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "470.87 467.44 430.06 394.77 510.57 259.2 471.88 190.32 514.55 118.48 594.06 260.03 470.87 467.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "361.32 510.92 361.2 510.71 336.08 465.99 295.16 393.14 376.57 256.06 460.12 257.13 378.74 394.15 444.94 512 361.32 510.92"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickmill);
export default __webpack_public_path__ + "static/media/tickmill.4841076e942ece389374aa57f4b9caa0.svg";
export { ForwardRef as ReactComponent };